import { render, staticRenderFns } from "./SlickItem.vue?vue&type=template&id=aee394e0&"
import script from "./SlickItem.vue?vue&type=script&lang=js&"
export * from "./SlickItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports